import React from 'react';
import AppIcon from "../img/logo/android-chrome-192x192.png";
const Footer = ()=>{
    return(
    <div className="footer-container app-bg-dark pt-3 pb-3">
        <div className="container">
          <div className="row">
             <div className="col-md-3 col-sm-12 col-xs-12 col-xl-3">
                 <p className="text-uppercase app-text-gray app-text-sm footer-section-header">company</p>
                 <ul className="list-unstyled">
                   <li><a href="/" className="app-text-white app-text-sm">About boogiee</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Contact Us</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Jobs</a></li>
                 </ul>
             </div>
             <div className="col-md-3 col-sm-12 col-xs-12 col-xl-3">
                 <p className="text-uppercase app-text-gray app-text-sm footer-section-header">help</p>
                 <ul className="list-unstyled">
                   <li><a href="/" className="app-text-white app-text-sm">Track My Music</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Community Support</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Community Guidelines</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">General Help</a></li>
                 </ul>
             </div>
             <div className="col-md-3 col-sm-12 col-xs-12 col-xl-3">
                 <p className="text-uppercase app-text-gray app-text-sm footer-section-header">featured</p>
                 <ul className="list-unstyled">
                   <li><a href="/" className="app-text-white app-text-sm">Download App</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Developer API</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Free Music Download</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Merchandise</a></li>
                 </ul>
             </div>
             <div className="col-md-3 col-sm-12 col-xs-12 col-xl-3">
                 <p className="text-uppercase app-text-gray app-text-sm footer-section-header">account</p>
                 <ul className="list-unstyled">
                   <li><a href="/" className="app-text-white app-text-sm">Join Community</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Sign In</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Subscribe</a></li>
                   <li><a href="/" className="app-text-white app-text-sm">Free Plans</a></li>
                 </ul>
             </div>
          </div>
        </div>
        <div className="app-bg-gray app-sm-line"></div>
        <div className="container p-2">
          <small className="app-text-white d-block mb-2 app-text-gray">Currently Supported Languages</small>
          <a href="/" className="app-text-xs app-text-white">English</a> 
          <a href="/" className="app-text-xs ml-3 app-text-gray">Deutsch</a> 
          <a href="/" className="app-text-xs ml-3 app-text-gray">Español</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Français</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Italiano</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Polski</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Português</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Русский</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Svenska</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">Türkçe</a>
          <a href="/" className="app-text-xs ml-3 app-text-gray">简体中文</a>   
          <a href="/" className="app-text-xs ml-3 app-text-gray">Kinyarwanda</a>   
          <div className="time-zone">
          <span className="app-text-xs app-text-gray">Time-Zone:&emsp;<i className="app-text-white">Africa-Kigali</i></span>
          </div>
        </div>

        <div className="container last-div">
        <small className="app-text-gray">&copy;{(new Date().getFullYear())} boogiee Ltd. All rights reserved 
        <div>
        <ul className="d-inline inline-lists">
          <br/>
           <li><a href="/" className="app-text-gray">Terms</a> of Use</li>
           <li><a href="/" className="app-text-gray">Privacy Policy</a></li>
           <li><a href="/" className="app-text-gray">Legal Policies</a></li>
           <li><a href="/" className="app-text-gray">Privacy/Info We Collect</a></li><br/>
           <li><a href="/" className="app-text-gray">Do Not Sell My Personal Information</a></li>
           <li><a href="/" className="app-text-gray">Jobs at boogiee Music</a></li>
         </ul>
        </div>
        </small>
        </div>
        <div className="logo d-flex flex-row justify-content-center mt-3">
         <p className="app-text-gray app-text-sm">Powered by boogiee</p>&emsp;
         <img src={AppIcon} alt="Logo footer" width="20" height="20"/>
        </div>
    </div>
    );
}

export default Footer;